module.exports = __webpack_public_path__ + "static/media/bloom.c614347a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/bloom.png
// module id = 1016
// module chunks = 0